import * as React from "react"
import Footer from "../../components/Footer"
import Navbar from "../../components/Navbar"
import Hero from "../../components/Hero"
import caseStudiesHero from "../../images/caseStudiesHero.png"
import aboutHeroSmall from "../../images/aboutHeroSmall.svg"
import caseStudiesCta from "../../images/caseStudiesCta.png"
import Cta from "../../components/Cta"
import CaseStudiesCards from "../../components/CaseStudiesPage/CaseStudiesCards"
import { caseStudyCards } from "../../content/caseStudies/registry"

const aboutHeroContent = {
  primaryTitle: "Unveiling Success Stories: Dive into Our  ",
  secondaryTitle: "Case Studies",
  description:
    "Explore real-world examples of how Cognetiks Consulting has transformed businesses through innovative cloud and DevOps solutions. Discover how we drive success and inspire growth through our tailored approaches and strategic partnerships.",
}

const systemCtaContent = {
  title: "Let’s help your organisation adopt cloud and devops best practices",
  description:
    "Supercharge your Cloud and DevOps journey with our expert team. We bring vast experience with leading technologies, ensuring a swift and efficient transformation.",
}

const CaseStudies = () => {
  return (
    <main>
      <Navbar />
      <Hero
        content={aboutHeroContent}
        image={[caseStudiesHero, aboutHeroSmall]}
        casestudy
      />
      <CaseStudiesCards showMoreBtn={false} casestudies={caseStudyCards} />
      <Cta
        color1="#242A60"
        color2="#5ABAFF"
        textColor="#2F467F"
        image={caseStudiesCta}
        content={systemCtaContent}
      />
      <Footer />
    </main>
  )
}

export default CaseStudies

export const Head = () => (
  <>
    <title>Case studies</title>
  </>
)
